import { Text } from '@lune-fe/lune-ui-lib'
import { Box, SxProps } from '@mui/material'
import { FC, ReactNode } from 'react'

const EmptyStatePlaceholder: FC<{
    illustration: string
    title: string
    description?: ReactNode
    sx?: SxProps
    extra?: ReactNode
}> = ({ illustration, sx, description, title, extra }) => {
    return (
        <Box
            sx={{
                width: '100%',
                minHeight: `240px`,
                p: 3,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: 3,
                boxSizing: 'border-box',
                '*': {
                    boxSizing: 'border-box',
                },
                ...sx,
            }}
        >
            <Box
                sx={{
                    backgroundColor: `Grey100`,
                    borderRadius: '24px',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        mb: -1,
                        width: '174px',
                        height: '120px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        img: {
                            width: '100%',
                        },
                    }}
                >
                    <img src={illustration} alt={'Empty state placeholder'} />
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    gap: 1 / 2,
                }}
            >
                <Text variant={'body2-medium'}>{title}</Text>
                {description && (
                    <Text variant={'body3'} sx={{ color: `TextSecondary` }}>
                        {description}
                    </Text>
                )}
            </Box>
            {extra}
        </Box>
    )
}

export default EmptyStatePlaceholder
